ch-smart-grid-cell.ch-smart-grid-cell-reserve-space {
  position: relative;
}
ch-smart-grid-cell.ch-smart-grid-cell-reserve-space::before {
  content: "";
  position: absolute;
  inline-size: 2px;
  block-size: var(--ch-smart-grid-smart-cell-reserved-space-size);
  visibility: hidden;
  pointer-events: none;
}